import cn from 'classnames';
import { observer } from 'mobx-react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useStores } from '@/hooks/use-stores';
import { EPButton } from '@/components';

import PressureRangesTable from './PressureRangesTable';
import { PressureLevelsContainer } from './styled';

const PressureLevels = observer(({ hasTriedToSubmit }: { hasTriedToSubmit: boolean }) => {
  const { t } = useTranslation();
  const { engineStore } = useStores();
  const {
    mainRangesConfiguration: { flowLevels, pressureLevels },
  } = engineStore;

  const [selectedFlowRangeIndex] = useState(0);

  const onAddClick = () =>
    pressureLevels.addRange(
      flowLevels.ranges?.[selectedFlowRangeIndex]?.key,
      pressureLevels.getPressureRangesByFlow(flowLevels.ranges?.[selectedFlowRangeIndex]?.key)?.length,
    );

  return (
    <PressureLevelsContainer $hasFinishedWizard={engineStore.hasFinishedWizard}>
      <div className={cn('table-container', engineStore.isReadOnly && 'disabled')}>
        <PressureRangesTable hasTriedToSubmit={hasTriedToSubmit} />
        {!engineStore.isReadOnly && (
          <EPButton size="medium" type="primary" onClick={onAddClick} className="add-pressure-range-button">
            <span className="button-label">{t('addPressureRange')}</span>
          </EPButton>
        )}
      </div>
    </PressureLevelsContainer>
  );
});

export default PressureLevels;
